import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box } from '@mui/material';

const INPUT_CONFIG = {
  deadlineDate: { type: 'date', label: 'Deadline Date' },
  deadlineTime: { type: 'time', label: 'Deadline Time' },
};

const EditFieldModal = ({ editModal, onValueChange, onClose, onSave, dateWritingInputType = 'date' }) => {
  const { open, field, title, value } = editModal;

  const handleChange = (e) => onValueChange(e.target.value);

  const renderField = () => {
    if (field === 'dateWriting') {
      return (
        <TextField
          type={dateWritingInputType}
          value={value}
          onChange={handleChange}
          fullWidth
          label={dateWritingInputType === 'datetime-local' ? 'Date and Time' : 'Date'}
          InputLabelProps={{ shrink: true }}
        />
      );
    }

    const config = INPUT_CONFIG[field];
    if (config) {
      return (
        <TextField
          type={config.type}
          value={value}
          onChange={handleChange}
          fullWidth
          label={config.label}
          InputLabelProps={{ shrink: true }}
        />
      );
    }

    return (
      <TextField
        value={value}
        onChange={handleChange}
        fullWidth
        multiline
        rows={4}
        label="Note"
        placeholder="Enter your note here..."
      />
    );
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>{renderField()}</Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onSave} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

EditFieldModal.propTypes = {
  editModal: PropTypes.shape({
    open: PropTypes.bool.isRequired,
    field: PropTypes.string,
    title: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  onValueChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  dateWritingInputType: PropTypes.oneOf(['date', 'datetime-local']),
};

export default EditFieldModal;
